"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/group.ts
var _group = require('@ariakit/react-core/group/group');
var _grouplabel = require('@ariakit/react-core/group/group-label');




exports.Group = _group.Group; exports.GroupLabel = _grouplabel.GroupLabel;
